import { PlateContent } from 'platejs/react';
import { ClassNames } from '@emotion/react';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
function Editor(props) {
  const {
    isDisabled,
    onPaste
  } = props;
  return _jsx(ClassNames, {
    children: ({
      css
    }) => _jsx(PlateContent, {
      className: css`
            flex-grow: 1;
            padding: 8px 20px 0;
            outline: none;
          `,
      disableDefaultStyles: true,
      readOnly: isDisabled,
      "aria-disabled": isDisabled,
      onPaste: onPaste
    })
  });
}
export default Editor;